<template>
  <div class="splitTabbed" :class="textColour" :style="bgStyle">
    <div class="wrapper text-center">
      <div class="splitTabbed__content">
        <h3 v-if="item[selected].category && isDesktop">
          {{ item[selected].category }}
        </h3>
        <div>
          <h2 v-if="item[selected].title">
            {{ item[selected].title }}
          </h2>
          <p v-if="item[selected].text" v-html="item[selected].text" />
          <div class="splitTabbed__content--button">
            <app-link v-if="item[selected].cta" :id="item[selected].linkId" :type="item[selected].linkType" :class="btnColour">
              {{ item[selected].cta }}
            </app-link>
          </div>
        </div>
        <div class="splitTabbed__content--menu" :class="borderColour">
          <ul>
            <li v-for="(tab, i) in item" :key="i" :class="[borderColour, { 'is-active': selected === i }]" tabindex="0" @click="selected = i">
              {{ tab.title }}
            </li>
          </ul>
        </div>
      </div>
      <div class="splitTabbed__divider" :class="dividerColour" />
      <div class="splitTabbed__image">
        <img :data-src="item[selected].bgImage" alt="SplitTabbed Image" class="lazyload">
      </div>
      <h3 v-if="item[selected].category && !isDesktop" class="splitTabbed__top">
        {{ item[selected].category }}
      </h3>
    </div>
  </div>
</template>

<script>
import responsive from '../mixins/responsive';

export default {
  name: 'SplitTabbed',
  mixins: [
    responsive,
  ],
  props: {
    bgColour: { type: String, required: true },
    // VALID themes are 'light' or 'dark'
    theme: { type: String, default: 'light' },
    item: { type: Array, required: true },
  },
  data() {
    return {
      selected: 0,
    };
  },
  computed: {
    textColour() {
      return {
        'text-dark': this.theme === 'dark',
        'text-light': this.theme === 'light',
      };
    },
    btnColour() {
      return {
        'btn-secondary-dark-sm': this.theme === 'dark',
        'btn-secondary-light-sm': this.theme === 'light',
      };
    },
    borderColour() {
      return {
        hide: this.item.length < 2,
        'border-bottom-dark': this.theme === 'dark',
        'border-bottom-light': this.theme === 'light',
      };
    },
    dividerColour() {
      return {
        'divider-dark': this.theme === 'dark',
        'divider-light': this.theme === 'light',
      };
    },
    bgStyle() {
      return {
        backgroundColor: this.bgColour,
      };
    },
  },
  methods: {
    getBackground(item) {
      return {
        backgroundImage: `url(${item.bgImage})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/settings/_config.scss';
.splitTabbed {
  height: 100%;
  @media screen and (min-width: 1023px) {
    max-height: 720px;
  }
  .wrapper {
    padding: 1em;
    display: flex;
    flex-direction: column-reverse;
    @media screen and (min-width: 1024px) {
      padding: 0;
      max-width: 1600px;
      display: grid;
      grid-template-columns: 1fr 1px 1fr;
      height: 100%;
    }
  }
  &__top {
    margin: 4em auto 2em;
  }
  &__content {
    padding: 2em;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    max-width: 640px;
    width: 100%;
    h2 {
      font-size: 32px;
      font-family: $font-family-editorial;
      @media screen and (min-width: 1023px) {
        font-size: 40px;
      }
    }
    p {
      height: 350px;
      font-size: 14px;
      @media screen and (min-width: 1023px) {
        height: 200px;
      }
    }
    a {
      margin-top: 1em;
    }
    &--menu {
      font-size: 14px;
      width: 100%;
      padding-bottom: 0;
      overflow-x: auto;
      scrollbar-width: none;
      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: transparent;
      }
      @media screen and (max-width: 1023px) {
        margin-top: 2em;
      }
      // ADD THICK BORDER TO IS ACTIVE (DEPENDING ON THEME COLOUR), AUTO SCROLL MENU ON MOBILE
      ul {
        text-transform: uppercase;
        display: flex;
        justify-content: center;
        align-items: center;
        width: max-content;
        display: flex;
        margin: 0 auto;
        li {
          cursor: pointer;
          display: inline-block;
          padding: 10px 20px;
          &.border-bottom-light {
            border-bottom: 1px solid $stoneWhite;
            &.is-active {
            font-weight: 500;
            border-bottom: 3px solid $stoneWhite;
            }
          }
          &.border-bottom-dark {
            border-bottom: 1px solid $darkBlack;
            &.is-active {
            font-weight: 500;
            border-bottom: 3px solid $darkBlack;
            }
          }
        }
      }
    }
  }
  &__divider {
    &.divider-dark {
      border-right: 1px solid $darkBlack;
    }
    &.divider-light {
      border-right: 1px solid $stoneWhite;
    }
  }
  &__image {
    margin: 2em;
    @media screen and (max-width: 1023px) {
      padding: 1em;
      margin: 0;
   }
   img {
    width: 100%;
    max-height: 600px;
    @media screen and (max-width: 1023px) {
      height: 376px;
      width: 100%;
    }
   }
  }
}

.hide {
  opacity: 0;
}

</style>
